<template>
  <div class="compete-award">
    <moduleTitle title1="大赛奖励" title2="AWARDS" id="compete-award" />
    <div class="award-content" id="compete-award1">
      <div class="h-tabs">
        <div class="h-tab-content">
          <div class="round">
            <div
              class="award-banner"
              :style="{ backgroundImage: `url(${mainAwardPic})` }"
            ></div>
            <div class="award-item-wrap">
              <div class="award-item award-item1">
                <div class="award-show">
                  <div class="award-title">
                    <div class="award-bg-mask">
                      <span>{{ awards[0].title }}</span>
                    </div>
                  </div>
                  <div class="award-img-wrap">
                    <img
                      class="award-img"
                      alt="award-img"
                      :src="awards[0].img"
                    />
                    <div class="award-desc-wrap">
                      <div class="award-subtitle">完成必做题后可选做本题</div>
                      <div
                        class="award-desc"
                        v-for="list in awards[0].desc"
                        :key="list"
                      >
                        {{ list }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="award-item">
                <div class="award-show">
                  <div class="award-title">
                    <div class="award-bg-mask">
                      <span>{{ awards[1].title }}</span>
                    </div>
                  </div>
                  <img class="award-img" alt="award-img" :src="awards[1].img" />
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AwardShow from './awardShow'
import moduleTitle from '../moduleTitle'

export default {
  name: 'CompeteAward',
  data() {
    return {
      rounds: window.financialCompetitionResource.competitionInfo.rounds, // 赛段tab信息
      activeAward: window.financialCompetitionResource.awardInfo.activeAward, // 进行中赛段奖励信息
      noteActivedAward:
        window.financialCompetitionResource.awardInfo.noteActivedAward // 非进行中赛段奖励信息【未开始、已结束】
    }
  },
  computed: {
    awards() {
      return window.financialCompetitionResource.awardInfo.awards
    },
    mainAwardPic() {
      return window.financialCompetitionResource.awardInfo.awardMainPic
    }
  },
  components: {
    AwardShow,
    moduleTitle
  }
}
</script>

<style lang="scss" scoped>
#compete-award,
#compete-award1 {
  opacity: 0;
}
.compete-award {
  max-width: 1200px;
  margin: 0 auto;
}
.award-content {
  width: inherit;
  margin: 40px auto 0;
  background: #fff;
  box-shadow: 0px 14px 40px 0px rgba(230, 230, 230, 1);
  border-radius: 25px;
}
.h-tabs {
  width: 100%;
  .h-tab-content {
    width: inherit;
    padding: 0 32px;
    box-sizing: border-box;
    position: relative;
    .round {
      width: 100%;
      position: relative;
      box-sizing: border-box;
      padding-bottom: 32px;
      .award-banner {
        width: calc(100% + 64px);
        height: 336px;
        position: relative;
        left: -32px;
        background: url('#') center center/cover no-repeat;
        border-radius: 25px 25px 0 0;
      }
    }
  }
  .award-item-wrap {
    margin-top: 32px;
    display: flex;
    padding: 0 40px;
    .award-item {
      box-sizing: border-box;
      width: 193px;
      height: 133px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 25px;
      margin-right: 113px;
      padding: 1px;
      background-image: linear-gradient(to right top, #3060ff, #0ff4f1);
      &:last-of-type {
        margin-right: 0;
      }
    }
    .award-item1 {
      width: 1055px;
    }
  }
}
.award-show {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  padding: 0 12px;
  border-radius: 23px;
  .award-title {
    width: 221px;
    height: 36px;
    line-height: 36px;
    background-color: #fff;
    border-radius: 0 100px 100px 0;
    position: absolute;
    left: -14px;
    top: -2px;
    border-radius: 0 100px 100px 0;
    font-weight: bold;
    color: #4686f2;
    font-family: Alibaba-PuHuiTi-B;
    text-align: center;
    font-size: 18px;
    padding: 1px;
    background-image: linear-gradient(to right, #3060ff, #0ff4f1);
    .award-bg-mask {
      background-color: #fff;
      height: 33px;
      border-radius: 0 100px 100px 0;
    }
    span {
      background-image: linear-gradient(90deg, #f14c5d, #8647dd);
      -webkit-background-clip: text;
      color: transparent;
    }
    &::after {
      content: '';
      display: inline-block;
      border-top: solid 4px #e5ccff;
      border-right: solid 6px #e5ccff;
      position: absolute;
      top: 35px;
      left: 0;
      border-bottom: solid 4px transparent;
      border-left: solid 6px transparent;
    }
  }
  .award-name {
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 16px;
    color: #333;
    line-height: 18px;
    position: absolute;
    left: 50%;
    top: 52px;
    transform: translateX(-50%);
    text-align: center;
    width: 90%;
    font-weight: 500;
  }
  .award-img {
    // width: 95px;
    height: 83px;
    position: absolute;
    top: 41px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.award-item1 {
  .award-img-wrap {
    display: flex;
    padding: 35px 0 0 23px;
    align-items: center;
  }
  .award-img {
    position: initial;
    width: 123px;
    height: 62px;
    transform: translateX(0%);
  }
  .award-desc-wrap {
    border-left: 1px solid #bad3df;
    margin-left: 63px;
    padding-left: 54px;
  }
  .award-subtitle {
    width: 199px;
    height: 24px;
    line-height: 22px;
    background-image: linear-gradient(36deg, #f14c5d 0%, #8647dd 100%);
    border-radius: 12px;
    text-align: center;
    font-family: AlibabaPuHuiTiR;
    font-size: 16px;
    color: #fff;
    margin-bottom: 4px;
  }
  .award-desc {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666;
    line-height: 20px;
    font-weight: 400;
    &::before {
      display: inline-block;
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #666;
      margin-right: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeAward/competeAward.vue